import { palette, ColorScale, definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import {
  accordionTheme,
  breadcrumbTheme,
  datatableTheme,
  dialogTheme,
  drawerTheme,
  listboxTheme,
  stepsTheme,
  tieredmenuTheme,
  toggleButtonTheme,
} from "./designtokens/components";

const primaryColor = palette("#337ab7") as ColorScale;

const myPreset = definePreset(Aura, {
  semantic: {
    primary: primaryColor,
  },
  components: {
    accordion: accordionTheme,
    datatable: datatableTheme,
    breadcrumb: breadcrumbTheme,
    dialog: dialogTheme,
    drawer: drawerTheme,
    listbox: listboxTheme,
    steps: stepsTheme,
    tieredmenu: tieredmenuTheme,
    togglebutton: toggleButtonTheme,
  },
});
 
export const pcpPrimeNgConfig = {
  theme: {
    preset: myPreset,
    options: {
      darkModeSelector: ".my-app-dark",
      cssLayer: {
        name: "primeng",
        order: "bootstrap, pcp, primeng",
      },
    },
  },
};